import { DisplayText } from "components/DisplayFields/DisplayText";
import { GridHeader } from "components/GridFields/GridHeader";
import { camelToDash } from "helpers";
import { createLogger } from "logging";
import { SuggestedAgendaItemModel } from "models/SuggestedAgendaItemModel";
import { useSuggestedAgendaItemPanel, useTranslations } from "providers";
import React from "react";

import { SuggestedAgendaItemsSelection } from "./SuggestedAgendaItemsSelection";

const logger = createLogger("SuggestedAgendaItemsForm");

export const SuggestedAgendaItemsForm: React.FC = () => {
  const i18n = useTranslations();
  const { filteredItems: items, selectedIds, onItemChange } = useSuggestedAgendaItemPanel();

  const onRowClicked = (item: SuggestedAgendaItemModel, tagName: string) => {
    logger.debug("onRowClicked(): ", tagName);
    if (!/td|tr|span/i.test(tagName)) {
      return;
    }

    onItemChange(item.id, !selectedIds.has(item.id));
  };

  return (
    <table className="table sbb-table-bs">
      <thead>
        <tr className="no-hover">
          <GridHeader
            className={camelToDash("Selection")}
            //title={i18n.SuggestedAgendaItems_Selection_Title}
            tooltip={i18n.SuggestedAgendaItems_Selection_Tooltip}
          />

          <GridHeader
            className={camelToDash("Title")}
            title={i18n.SuggestedAgendaItems_Title}
            tooltip={i18n.SuggestedAgendaItems_Title_Tooltip}
          />

          <GridHeader
            className={camelToDash("Meeting")}
            title={i18n.SuggestedAgendaItems_Meeting}
            tooltip={i18n.SuggestedAgendaItems_Meeting_Tooltip}
          />
        </tr>
      </thead>
      {items.length == 0 && (
        <tbody>
          <tr>
            <td colSpan={3} className="text-center">
              {i18n.EmptyTable}
            </td>
          </tr>
        </tbody>
      )}

      {items.length > 0 && (
        <tbody>
          {items.map((item) => {
            const id = item.id;
            const key = `key-${id}`;

            return (
              <tr
                onClick={(e) => {
                  const tagName = e.currentTarget.tagName;
                  onRowClicked(item, tagName);
                }}
                key={key}
              >
                <td className="selection">
                  <SuggestedAgendaItemsSelection id={item.id} />
                </td>
                <td className="title">
                  <DisplayText value={item.sourceAgendaItem.title} />
                </td>
                <td className="meeting">
                  <DisplayText value={item.sourceMeeting.title} />
                </td>
              </tr>
            );
          })}
        </tbody>
      )}
    </table>
  );
};
